import { snakeKeys, camelKeys } from "./caseTransformers";
export const v2RequestSnakeCaseTransformer = (data) => {
    // Early return for null/undefined
    if (!data)
        return data;
    // Cache URL check - use indexOf for faster lookup
    const url = data.url;
    if (!url || url.indexOf("/v2/") === -1) {
        return data;
    }
    const dataPayload = data.data;
    if (dataPayload && !(dataPayload instanceof FormData)) {
        data.data = snakeKeys(dataPayload);
    }
    if (data.params) {
        data.params = snakeKeys(data.params);
    }
    return data;
};
export const v2ResponseCamelCaseTransformer = (data) => {
    // Early return for primitives
    if (!data || typeof data !== 'object') {
        return data;
    }
    // Cache nested property access and use indexOf
    const config = data.config;
    if (config) {
        const url = config.url;
        if (url && url.indexOf("/v2/") !== -1) {
            data.data = camelKeys(data.data);
        }
    }
    return data;
};
